import { makeStyles } from "@material-ui/core/styles";

export default makeStyles({
  rowOdd: {
    backgroundColor: "#F6F6F6"
  },
  rowWrapper: {
    padding: "32px 16px 2px 16px"
  },
  rowContent: {
    display: "grid",
    gap: 6
  }
});
